import React, { useCallback } from "react";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
import {configuration} from "e.sic-platform.webclient/src/services/configuration/ConfigurationService"


export default observer(function Head() {
  const [ configurationContent, setConfig ] = useState<any>(null);
 
  useEffect(() => {
    if(!configurationContent)
    configuration.get().then((response:any) => setConfig(response))
  }, [configurationContent])

  const getFullPageTitle = useCallback(() => {
    if (!configurationContent) return " ";
    return `${configurationContent.browser_title}`;
  }, [configurationContent]);

  return configurationContent ? (
    <Helmet>
      <title>{getFullPageTitle()}</title>
    </Helmet>
  ) : null;
});
